import CryptoJS from "crypto-js";
import axios from "axios";
import { toasts } from "../components/common/Toast/Toast";
import { store } from "../app/store";
import { isUserLogin } from "../features/persist/persistSlice";
import { stopLoading } from "../features/loading/loadingSlice";

const CRYPTOJS_SECRET_KEY = process.env.REACT_APP_ENCRYPTION_SECRET_KEYS;
const ENABLE_ENCRYPTION = process.env.REACT_APP_ENABLE_ENCRYPTION;

let sessionExpiredMessageShown = false;

// Encrypt function
export const encryptText = (text) => {
  if (!text) return "";
  try {
    const encrypted = CryptoJS.AES.encrypt(
      text,
      CRYPTOJS_SECRET_KEY
    ).toString();
    return encrypted;
  } catch (error) {
    console.error("Error during encryption:", error);
    return "";
  }
};

// Decrypt function
export const decryptText = (encryptedText) => {
  if (!encryptedText) return "";
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, CRYPTOJS_SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedText)
      throw new Error("Decryption failed. Invalid data or key.");
    return decryptedText;
  } catch (error) {
    console.error("Error during decryption:", error);
    return "";
  }
};

// Helper function to handle session expiration
const handleSessionExpiration = (err) => {
  const isLoginApi = err?.config?.url?.includes("login"); // new
  if (
    err.response &&
    err.response.status === 401 &&
    !sessionExpiredMessageShown &&
    !isLoginApi // new
  ) {
    sessionExpiredMessageShown = true;
    store.dispatch(isUserLogin(false));
    toasts.error("Session expired");
    store.dispatch(stopLoading());
  }
};

// Fetch Function with Encryption/Decryption Support
export const fetch = (method, url, data, headers, params = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      let requestData = data;
      let requestParams = params;

      // Encrypt request data for POST/PUT/PATCH if encryption is enabled
      if (ENABLE_ENCRYPTION === "YES") {
        if (
          method.toUpperCase() === "POST" ||
          method.toUpperCase() === "PUT" ||
          method.toUpperCase() === "PATCH"
        ) {
          requestData =
            data && Object.keys(data).length > 0
              ? { data: encryptText(JSON.stringify(data)) }
              : {};
        } else if (
          method.toUpperCase() === "GET" ||
          method.toUpperCase() === "DELETE"
        ) {
          if (params && Object.keys(params).length > 0) {
            requestParams = { data: encryptText(JSON.stringify(params)) };
          }
        }
      }


      const response = await axios({
        method,
        url,
        withCredentials: true,
        headers: { token: headers },
        params:
          method.toUpperCase() === "GET" ||
            (method.toUpperCase() === "DELETE" && requestParams)
            ? requestParams
            : undefined,
        data:
          method.toUpperCase() === "POST" ||
            method.toUpperCase() === "PUT" ||
            method.toUpperCase() === "PATCH"
            ? requestData
            : undefined,
      });

      // Decrypt response data if encryption is enabled
      if (ENABLE_ENCRYPTION === "YES" && response?.data?.data) {
        const decryptedData = decryptText(response.data.data);
        if (!decryptedData) {
          console.warn(
            "Decryption failed. No data returned. Setting default value."
          );
          response.data.data = {};
        } else {
          response.data.data = JSON.parse(decryptedData);
        }
      }

      resolve(response);
    } catch (err) {
      console.error(`API Response Error: ${method.toUpperCase()} ${url}`, {
        status: err?.response?.status,
        message: err?.message,
        error: err?.response?.data,
      });
      handleSessionExpiration(err);
      reject(err);
    }
  });
};